export function mapAuthLoginError(err: any): string {
  const status: number = err?.status ?? 0;
  const raw: string = (err?.error?.message ?? '').toLowerCase();

  if (status === 0 || err?.name === 'TimeoutError') {
    return 'No pudimos conectarnos. Revisa tu conexión e inténtalo nuevamente.';
  }

  const wrongRole = _parseWrongRoleAdmin(raw);
  if (wrongRole) return wrongRole;

  if (raw.includes('verifi')) {
    return 'Debes verificar tu correo antes de iniciar sesión.';
  }
  if (raw.includes('desactiv') || raw.includes('eliminad')) {
    return 'Tu cuenta no está disponible. Contacta a soporte para más información.';
  }
  if (status === 401 || raw.includes('credencial')) {
    return 'El correo o la contraseña son incorrectos.';
  }

  return 'Ocurrió un error inesperado. Inténtalo nuevamente.';
}

export function mapAuthCodeError(err: any, message?: string | null): string {
  const raw = ((err?.error?.message ?? message) ?? '').toLowerCase();

  if (raw.includes('expirad') || raw.includes('expired')) {
    return 'El código ha expirado. Solicita uno nuevo.';
  }
  return 'El código ingresado no es válido. Verifícalo e inténtalo nuevamente.';
}

function _parseWrongRoleAdmin(rawLower: string): string | null {
  if (!rawLower.includes('perfil incorrecto:')) return null;
  return 'Esta cuenta no tiene acceso de administrador. Contacta al equipo de soporte.';
}
